goog.provide("shadow.js.shim.module$src$svg$wpp$content$smartphone_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content$smartphone_svg");
shadow.js.shim.module$src$svg$wpp$content$smartphone_svg = shadow.js.nativeProvides["src/svg/wpp/content/smartphone.svg"] = shadow$bridge("src/svg/wpp/content/smartphone.svg");
module$shadow_js_shim_module$src$svg$wpp$content$smartphone_svg.default = shadow.js.shim.module$src$svg$wpp$content$smartphone_svg;
